export default "__VITE_ASSET__783ffbff__"